<template>
  <div v-if="isLoading" class="d-flex justify-center align-center">
    <v-row no-gutters class="px-12 py-6">
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-progress-circular
          indeterminate
          color="#2661FF"
          size="80"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>{{ $t('organization.details.tabs.modules.title') }}</p>
      </v-card-title>
      <v-card-text>
        <v-list two-line>
          <template v-for="item of modulesLocal">
            <v-divider />
            <v-list-item>
              <v-list-item-content class="ml-2">
                <v-list-item-title>
                  <span>{{ item.name }}</span>
                </v-list-item-title>
                <v-list-item-subtitle class="mt-1">
                  <span class="caption">{{ item.info }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="mx-4">
                <v-row :class="item.config ? 'mt-1' : ''">
                  <v-col cols="6" :class="!item.config ? 'mr-15' : ''">
                    <v-switch
                      :disabled="item.disabled"
                      :readonly="isUpdateLoading"
                      color="#2661FF"
                      v-model="item.active"
                      @change="toggleModule(item.id)"
                      :class="!item.config ? 'mr-16' : ''"
                    ></v-switch>
                  </v-col>
                  <v-col cols="6" v-if="item.config">
                    <v-btn
                      icon
                      color="grey"
                      @click="dispatchMethod(item.configDispatch)"
                      class="pb-2 text--darken-3"
                    >
                      <v-icon size="28">
                        edit_square
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'organizationModules',
  data() {
    return {
      isLoading: false,
      isUpdateLoading: false,
      modulesLocal: [],
      modulesInfo: [
        {
          name: 'Essentials',
          value: this.$t('organization.details.tabs.modules.essentials')
        },
        {
          name: 'Crowdfunding',
          value: this.$t('organization.details.tabs.modules.crowdfunding')
        },
        {
          name: 'Petition',
          value: this.$t('organization.details.tabs.modules.petition')
        },
        {
          name: 'Docs',
          value: this.$t('organization.details.tabs.modules.docs')
        },
        {
          name: 'Landing',
          value: this.$t('organization.details.tabs.modules.landing')
        },
        {
          name: 'Automation',
          value: this.$t('organization.details.tabs.modules.automation')
        },
        {
          name: 'Console',
          value: this.$t('organization.details.tabs.modules.console')
        }
      ],
      selectedModules: []
    }
  },
  async created() {
    try {
      this.isLoading = true
      await this.getOrganizationModules(this.organization.id)
    } catch (error) {
      this.$noty.error(this.$t('organization.details.tabs.modules.error'))
    } finally {
      this.isLoading = false
    }
  },
  watch: {
    orgModules(newVal, oldVal) {
      let modules = JSON.parse(JSON.stringify(this.modules))
      let modls = modules.map(mod => {
        if (mod.name === 'Automation') {
          return {
            config: true,
            configDispatch: {
              name: 'openAmazonSESConfig',
              value: 'automation'
            },
            id: mod.id,
            name: mod.name,
            active: !!newVal.find(el => el.id === mod.id),
            info: this.modulesInfo.find(el => el.name === mod.name).value,
            disabled: mod.name === 'Essentials'
          }
        } else {
          return {
            id: mod.id,
            name: mod.name,
            active: !!newVal.find(el => el.id === mod.id),
            info: this.modulesInfo.find(el => el.name === mod.name).value,
            disabled: mod.name === 'Essentials'
          }
        }
      })
      modules.forEach(organizationMod => {
        newVal.forEach(mod => {
          if (organizationMod.id === mod.id) {
            this.selectedModules.push(organizationMod.id)
          }
        })
      })
      this.modulesLocal = modls
    }
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      modules: ({ organization: { modules } }) => modules,
      orgModules: ({ organization: { orgModules } }) => orgModules
    })
  },
  methods: {
    ...mapActions({
      getOrganizationModules: 'organization/getOrganizationModules',
      updateOrganizationModules: 'organization/updateOrganizationModules'
    }),
    ...mapMutations({
      setType: 'accounts/setType',
      toggleAmazonSESConfig: 'accounts/toggleAmazonSESConfig'
    }),
    dispatchMethod(dispatch) {
      const { name, value } = dispatch
      this[name](value)
    },
    openAmazonSESConfig(type) {
      this.setType(type)
      this.toggleAmazonSESConfig(true)
    },
    // This method allows to toggle modules, i had to send all modules at once because of the back-end controller but the convenient way is to send only the one that is being toggled
    async toggleModule(id) {
      this.isUpdateLoading = true
      const exist = this.selectedModules.indexOf(id)
      if (exist !== -1) {
        this.selectedModules.splice(exist, 1)
      } else {
        this.selectedModules.push(id)
      }
      const modules = this.selectedModules
      this.selectedModules = []

      try {
        const response = (
          await this.updateOrganizationModules({
            id: this.organization.id,
            body: {
              modules
            }
          })
        ).data

        if (response.success) {
          this.$noty.success(
            this.$t('organization.details.tabs.modules.success')
          )
        } else {
          this.$noty.error(this.$t('organization.details.tabs.modules.error'))
        }
      } catch (error) {
        this.selectedModules = modules
        this.$noty.error(this.$t('organization.details.tabs.modules.error'))
      } finally {
        this.isUpdateLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
